import { useTranslation } from 'react-i18next';
import { comparisonAgentesData } from '@/mocks/comparison';

export default function ComparisonSection() {
  const { t } = useTranslation();

  return (
    <section className="flex flex-col lg:flex-row min-h-[600px]">
      <div className="w-full lg:w-1/2 bg-background-100 relative overflow-hidden flex items-end p-8 md:p-12 lg:p-16 min-h-[400px] lg:min-h-[600px]">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20workspace%20with%20two%20laptops%20side%20by%20side%20showing%20comparison%20charts%2C%20coffee%20cup%20on%20desk%2C%20indoor%20plant%20in%20background%2C%20bright%20morning%20light%20through%20blinds%2C%20professional%20yet%20cozy%20atmosphere%2C%20data%20analysis%20aesthetic%2C%20warm%20wood%20desk%2C%20natural%20textures&width=960&height=1200&seq=comparison-lifestyle-v3&orientation=portrait"
          alt="HoobuySpreadsheet comparison"
          title="HoobuySpreadsheet vs agentes tradicionais"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/50 to-transparent"></div>
        <div className="relative z-10">
          <span className="text-xs font-label font-semibold tracking-widest uppercase text-accent-200 mb-3 block">
            {t('comparison_label')}
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight">
            {t('comparison_title')}
          </h2>
        </div>
      </div>

      <div className="w-full lg:w-1/2 bg-background-50 flex items-center px-4 md:px-8 lg:px-16 py-16 lg:py-0">
        <div className="max-w-lg w-full">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight mb-6">
            {t('comparison_subtitle')}
          </h2>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8">
            {t('comparison_desc')}
          </p>

          <div className="space-y-4 mb-8">
            {comparisonAgentesData.map((row, idx) => (
              <div key={idx} className="flex items-center justify-between py-3 border-b border-background-200/70 last:border-0">
                <span className="text-sm font-medium text-foreground-700 font-label">{row.criterio}</span>
                <div className="flex items-center gap-4">
                  <span className="text-sm font-semibold text-primary-500 font-label">{row.hoobuy}</span>
                  <span className="text-xs text-foreground-400">{row.concorrente}</span>
                </div>
              </div>
            ))}
          </div>

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="group inline-flex items-center gap-3 bg-primary-500 text-background-50 dark:text-foreground-950 font-label font-semibold text-sm px-7 py-4 rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <span>{t('comparison_cta')}</span>
            <span className="w-7 h-7 flex items-center justify-center border border-background-50/40 rounded-full transition-transform duration-200 group-hover:translate-x-0.5">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}